import React, { useEffect, useState } from 'react';
import clienteAxios from '../../../../config/clientAxios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, PointElement, LineElement, } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import Cargando from '../../../extras/Cargando';
import { Tabs, Tab } from 'react-bootstrap';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, PointElement, LineElement);

const SuperficieSembrada = () => {
    const [statusTotal, setStatusTotal] = useState(undefined);
    const [statusTipo, setStatusTipo] = useState(undefined);
    const [total, setTotal] = useState({ "datasets": [], "labels": [] });
    const [tipo, setTipo] = useState({ "datasets": [], "labels": [] });
    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            }
        }
    };
    const [key, setKey] = useState('total');
    useEffect(() => {
        const getTotal = async () => {
            await clienteAxios.get(`cieg/agricultura_ganaderia/superficie_sembrada/total`, { timeout: 30000 })
                .then(response => {
                    setStatusTotal(true);
                    setTotal(response.data.datasets);
                }).catch(error => {
                    setStatusTotal(false);
                    console.error(error);
                });
        }
        const getTipo = async () => {
            await clienteAxios.get(`cieg/agricultura_ganaderia/superficie_sembrada/tipo`, { timeout: 30000 })
                .then(response => {
                    setStatusTipo(true);
                    setTipo(response.data.datasets);
                }).catch(error => {
                    setStatusTipo(false);
                    console.error(error);
                });
        }
        getTotal();
        getTipo();
    }, []);
    return (
        <div className='container'>
            <Tabs
                activeKey={key}
                onSelect={(k) => setKey(k)}
                className="mb-3">
                <Tab eventKey="total" title="Total">
                    <div className='row justify-content-md-center'>
                        {statusTotal === true ? <Bar data={total} options={options} /> : <Cargando />}
                    </div>
                </Tab>
                <Tab eventKey="tipo" title="Tipo">
                    <div className='row justify-content-md-center'>
                        {statusTipo === true ? <Bar data={tipo} options={options} /> : <Cargando />}
                    </div>
                </Tab>
            </Tabs>
            <div className='row'>
                <div className='col-lg-8' style={{ textAlign: 'left', fontSize: '12px' }}>
                    <p><strong>Fuente: </strong><i>{"Servicio de Información Agroalimentaria y Pesquera"}</i></p>
                </div>
            </div>
        </div>
    );
}
export default SuperficieSembrada;